import { Component, OnInit, AfterViewInit, OnChanges, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { GruaTecnicsFilterService } from '../../services/grua-tecnics-filter.service';
import { GruaTecnics } from '../../models/grua-tecnics.model';
import { GruaTecnicsFilter } from '../../models/grua-tecnics-filter';
import { GruaTecnicsService } from '../../services/grua-tecnics.service';


@Component({
  selector: 'app-grua-tecnics-table',
  templateUrl: './grua-tecnics-table.component.html',
  styleUrls: ['./grua-tecnics-table.component.scss']
})
export class GruaTecnicsTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: GruaTecnics[];
  dataSource: CustomDataSource<GruaTecnics, GruaTecnicsFilter>;
  filter: GruaTecnicsFilter = new GruaTecnicsFilter('codi', 'asc');
  displayedItems = [];
  highlightedRows = [];
  @Input() selectButton: boolean;
  @Input() updatedFilterData: GruaTecnicsFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();

  displayedColumns = ['codi', 'nom'];

  constructor(
    private gruaTecnicsService: GruaTecnicsService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
    this.selectButton = false;
  }

  ngOnInit() {
    if (this.selectButton) {
      this.displayedColumns = ['incorpora'].concat(this.displayedColumns);
    }
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<GruaTecnics, GruaTecnicsFilter>(this.paginator, new GruaTecnicsFilterService(), 'urlGetGruaTecnics', 'urlGetGruaTecnicsCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        this.filterService.saveFilter('grua-tecnics-filter', this.filter);
      }
    });

    this.filterService.loadFilter('grua-tecnics-filter', this.filter);
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.gruaTecnicsService, filter, this.i18n('Tècnics'), this.sort.direction, this.sort.active)
    });
  }

  selectCurrent(codi, somId) {
    this.itemSelected.next({codi: codi, idTecnic: somId});
  }

}
